"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeLanguageMenu = void 0;
const language_1 = __importDefault(require("./json/language"));
function getUserLanguage() {
    let languageCode = navigator.language || navigator.userLanguage;
    return languageCode ? languageCode.split('-')[0] : null;
}
function getTranslation(languageCode) {
    return language_1.default && language_1.default[languageCode] ? language_1.default[languageCode] : null;
}
function changeLanguageMenuButtonLabel(translation, languageCode) {
    const languageLabel = document.querySelector('#site-language-menu-button .c-button__label-text');
    if (languageLabel) {
        languageLabel.textContent = translation;
        languageLabel.setAttribute('lang', languageCode);
    }
}
function initializeLanguageMenu() {
    const languageCode = getUserLanguage();
    if (!languageCode) {
        return;
    }
    ;
    const translation = getTranslation(languageCode);
    if (!translation) {
        return;
    }
    ;
    document.addEventListener('DOMContentLoaded', () => {
        changeLanguageMenuButtonLabel(translation, languageCode);
    });
}
exports.initializeLanguageMenu = initializeLanguageMenu;
